import { nextInt } from './rng.js';
/** Цвета следующей капсулы: две независимые половины, все сочетания равновероятны. */
export function generatePieceColors(rngState, colorCount) {
    const first = nextInt(rngState, colorCount);
    const second = nextInt(first.state, colorCount);
    return { colors: [first.value, second.value], state: second.state };
}
//# sourceMappingURL=piece-generator.js.map